import css from "./Notification.module.css";
export default function Notification() {
  return (
    <>
      <p className={css.notification}>No feedback yet</p>
    </>
  );
}
